module.exports = __webpack_public_path__ + "static/media/Porsche.de289bed.jpeg";